'use strict';

const { parseTopBids, parseBidData } = require('./adformResponseParserHelpers');
const adformConstants = require('../adformConstants');
const adformEventDispatcher = require('../adformEventDispatcher');

/**
 * Returns array of parsed bid objects that can be used to generate html (img ad with link).
 * @param {Array} topBids - array of bids from response (sorted by price)
 * @return {Object[]} - array of parsed bid objects
 */
function getValidBids(topBids) {
    let validBids = [];
    for (let i = 0; i < topBids.length; i++) {
        const bid = topBids[i];
        const parsedBid = parseBidData(bid);
        if (!parsedBid) {
            // eslint-disable-next-line no-continue
            continue;
        }

        validBids.push(parsedBid);
    }

    return validBids;
}

/**
 * Handles when adform doesn't return bids (informs other modules e.g. to remove placeholder/loader if added)
 * @param {Object} additionalEventData - additional data needed to process adform data
 */
function handleNoBids(additionalEventData) {
    const eventData = {
        detail: {
            additionalEventData: additionalEventData
        }
    };
    adformEventDispatcher.dispatch(adformConstants.HOMEPAGE_RECOMMENDED_PRODUCTS_NO_BIDS_CUSTOM_EVENT_NAME, eventData);
}

/**
 * Handles adform returned bids (informs other modules e.g. to inject products in "homepage recommendation slider")
 * @param {Object[]} bids - array of parsed bid objects (img, links...)
 * @param {Object} additionalEventData - additional data needed to process adform data
 */
function handleHasBids(bids, additionalEventData) {
    const eventData = {
        detail: {
            bids: bids,
            additionalEventData: additionalEventData
        }
    };
    adformEventDispatcher.dispatch(adformConstants.HOMEPAGE_RECOMMENDED_PRODUCTS_BIDS_READY_CUSTOM_EVENT_NAME, eventData);
}

/**
 * Handles when adform request if not valid
 * @param {Object} additionalEventData - additional data needed to process adform data
 */
function handleInvalidRequest(additionalEventData) {
    handleNoBids(additionalEventData);
}

/**
 * Handles when adform request if not valid
 * @param {Object} error - error from try and catch
 * @param {Object} additionalEventData - additional data needed to process adform data
 */
function handleError(error, additionalEventData) {
    // todo: handle error
    // eslint-disable-next-line no-unused-vars
    let e = error;
    handleNoBids(additionalEventData);
}

/**
 * Handles adform 200 code response that has bids data.
 * Converts bids from response into parsed objects and sends them with dispatchEvent to other module
 * (e.g. to fetch products based on sku from response).
 * If not valid bids, informs other modules (e.g. if there is placeholder to be removed)
 *
 * @param {Object} data - adform response
 @param {Object} additionalEventData - additional data needed to process adform data
 */
function handleBidsResponse(data, additionalEventData) {
    try {
        const topBids = parseTopBids(data, adformConstants.HOMEPAGE_RECOMMENDED_PRODUCTS_NUM_OF_BIDS);
        if (!topBids.length) {
            handleNoBids(additionalEventData);
            return;
        }

        let validBids = getValidBids(topBids);
        if (!validBids.length) {
            handleNoBids(additionalEventData);
            return;
        }
        handleHasBids(validBids, additionalEventData);
    } catch (e) {
        handleError(e, additionalEventData);
    }
}

module.exports = {
    handleInvalidRequest: handleInvalidRequest,
    handleNoBids: handleNoBids,
    handleError: handleError,
    handleBidsResponse: handleBidsResponse
};
